import {Component} from '@angular/core';
import {RouterOutlet} from '@angular/router';


@Component({
  selector: 'app-hbu',
  imports: [
    RouterOutlet
  ],
  template: `
    <router-outlet/>
  `
})
export class HbuComponent {}
